import { IListingApiResponse, ILocationPayload } from './interface';

export const getListingData = async (apiEndpoint: string, payload?: ILocationPayload): Promise<IListingApiResponse> => {
	try {
		const response = await fetch(apiEndpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payload)
		});
		if (!response.ok) {
			throw new Error('Failed to fetch data from API');
		}
		const data: IListingApiResponse = await response.json();
		return data;
	} catch (error) {
		console.error('Error fetching data from API:', error);
		throw new Error('Error fetching data from API');
	}
};
